import { getActiveBillingStrategy } from "~/class/billing"
import { usePosProductsStore } from "~/stores/pos.products"

/**
 * The `skipService` resolver for the shop's active billing strategy, or
 * `undefined` when the strategy never reads that tag.
 *
 * Why this is gated rather than always passed: calculateItems calls the resolver
 * once per line on EVERY billing pass, and merely touching
 * `isBillingSkipServiceSubItem` builds a sub-item → type map across the whole
 * catalog. On the default strategy nothing reads the resulting flag, so all of
 * that work produced a value no one looked at. Returning undefined makes
 * calculateItems take its `: false` branch with no call at all.
 *
 * Deliberately NOT a Pinia getter: the gate reads module state that is seeded at
 * startup (settings.applyBillingStrategy), and a cached getter could freeze the
 * pre-settings answer. A plain function re-checks every time and is free.
 *
 * Shared by every calculateItems caller that prices a real bill, so the terminal
 * cart and the table cards can never disagree about the tag.
 */
export function activeSkipServiceResolver(): ((subItemId: any) => boolean) | undefined {
    if (!getActiveBillingStrategy().usesSkipService) return undefined
    return usePosProductsStore().isBillingSkipServiceSubItem
}
